import { BANNER } from '@shoflo/polymer/constants/SourceItems';
import { withCurrentParams } from 'actions/utils';
import { BANNER_ADD } from 'store/eventConstants';
import { BROADCAST_CREATE_BANNER } from 'actions/Types';
import { BannerStyles, BASIC_BANNER } from 'constants/LayerPositions';

/**
 * For the time being, this accepts all the banner source properties, except for the source type
 */
export default source => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, _, socket) => {
      const action = {
        type: BROADCAST_CREATE_BANNER,
        request: async apiClient => {
          const payload = {
            source: {
              ...source,
              type: BANNER
            },
            layer: {
              title: BASIC_BANNER,
              style: BannerStyles[BASIC_BANNER]
            }
          };

          const broadcast = await apiClient.broadcast.createBanner(
            teamId,
            eventId,
            broadcastId,
            payload
          );
          const { banners } = broadcast;
          // notify other directors
          socket.emit(BANNER_ADD, { broadcastId });
          return banners;
        }
      };
      dispatch(action);
    }
  );
};
